import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';
import { ToastComponent, ToastConfig, ToastType } from '../../components/toast/toast.component';

@Injectable({ providedIn: 'root' })
export class ToastService {
  constructor(
    private readonly toastrService: ToastrService,
    private translateService: TranslateService,
  ) {}

  info(message: string, centered = false, critical = false, interpolateParams: Record<string, string> = null) {
    return this.showToast('info', message, centered, critical, interpolateParams);
  }

  success(message: string, centered = false, critical = false, interpolateParams: Record<string, string> = null) {
    return this.showToast('success', message, centered, critical, interpolateParams);
  }

  warning(message: string, centered = false, critical = false, interpolateParams: Record<string, string> = null) {
    return this.showToast('warning', message, centered, critical, interpolateParams);
  }

  error(message: string, centered = false, critical = false, interpolateParams: Record<string, string> = null) {
    return this.showToast('error', message, centered, critical, interpolateParams);
  }

  blocked(message: string, interpolateParams: Record<string, string> = null) {
    return this.showToast('blocked', message, true, true, interpolateParams);
  }

  locked(message: string, interpolateParams: Record<string, string> = null) {
    return this.showToast('locked', message, true, true, interpolateParams);
  }

  show(type: ToastType, message: string, centered = false, critical = false, interpolateParams: Record<string, string> = null) {
    return this.showToast(type, message, centered, critical, interpolateParams);
  }

  private showToast(type: ToastType, message: string, centered = false, critical = false, interpolateParams: Record<string, string> = null) {
    const text = this.translateService.instant(message, interpolateParams);

    return this.toastrService.show<ToastConfig>(text, null, {
      easing: 'ease-in',
      easeTime: 200,
      enableHtml: true,
      disableTimeOut: critical,
      tapToDismiss: false,
      toastClass: '',
      positionClass: centered ? 'toast-top-center' : 'toast-top-right',
      toastComponent: ToastComponent,
      payload: { type, extraWidth: critical },
    });
  }
}
